module.exports = __webpack_public_path__ + "3fb338d92663715eb789c1ddf45246fd.jpg";